import React from "react";
import ThemeProvider from "./src/context/ThemeContext";

// Wrap the entire app with ThemeProvider
export const wrapRootElement = ({ element }) => {
  return <ThemeProvider>{element}</ThemeProvider>;
};

// Insert dark mode script into the head to prevent flash of light content
export const onRenderBody = ({ setHeadComponents }) => {
  setHeadComponents([
    <script
      key="dark-mode-script"
      dangerouslySetInnerHTML={{
        __html: `
          (function() {
            try {
              // Default to dark mode
              document.documentElement.classList.add('dark');
              document.body.classList.add('dark-mode');
              
              // Check localStorage only after that
              const savedTheme = localStorage.getItem('theme');
              const prefersDark = savedTheme ? savedTheme === 'dark' : true;
              
              if (!prefersDark) {
                document.documentElement.classList.remove('dark');
                document.body.classList.remove('dark-mode');
                document.body.classList.add('light-mode');
              }
            } catch (e) {
              // If localStorage is not available, default to dark mode
              document.documentElement.classList.add('dark');
              document.body.classList.add('dark-mode');
            }
          })();
        `,
      }}
    />,
  ]);
};
